module.exports = __webpack_public_path__ + "media/images/logo-989081cc80528b61341c543d6287f022.png";